import { HeaderProps } from '../../../src/entities/header';

const HIDE_QUOTE_BAR_PREFIXES = ['/account', '/profile/portfolio'] as const;

const matchesPrefix = (pathname: string, prefix: string) => pathname === prefix || pathname.startsWith(`${prefix}/`);

export function getChromeConfig(pathname: string): HeaderProps {
  if (pathname === '/') {
    return {
      showRotatingBanner: true,
    };
  }

  if (pathname === '/logout') {
    return {
      hideBanner: true,
      hideQuoteBar: true,
    };
  }

  if (pathname.startsWith('/money/preview/')) {
    return {
      hideBanner: true,
      hideQuoteBar: true,
      hideSearchBar: true,
      isMainDrawerVisible: true,
    };
  }

  if (pathname.startsWith('/applications/')) {
    return {
      hideBanner: true,
      hideQuoteBar: true,
    };
  }

  if (pathname.startsWith('/author/')) {
    return {
      hideBanner: true,
      hideMenuBar: true,
      hideQuoteBar: true,
      hideSearchBar: true,
      isMainDrawerVisible: true,
    };
  }

  if (HIDE_QUOTE_BAR_PREFIXES.some(prefix => matchesPrefix(pathname, prefix))) {
    return { hideQuoteBar: true };
  }

  if (pathname === '/services') {
    return { sticky: false, showRotatingBanner: false };
  }

  return {};
}

export function applyChromeConfig(pathname: string, headerProps: HeaderProps): HeaderProps {
  const chrome = getChromeConfig(pathname);
  const hideQuoteBar =
    chrome.hideQuoteBar ??
    (HIDE_QUOTE_BAR_PREFIXES.some(prefix => matchesPrefix(pathname, prefix)) ? true : headerProps.hideQuoteBar);

  const showRotatingBanner =
    chrome.showRotatingBanner ??
    (typeof headerProps.showRotatingBanner === 'boolean' ? headerProps.showRotatingBanner : false);

  const showRaptiveBanner = showRotatingBanner ? false : (headerProps.showRaptiveBanner ?? true);

  return {
    ...headerProps,
    hideBanner: chrome.hideBanner ?? false,
    hideFooter: chrome.hideFooter ?? headerProps.hideFooter,
    hideMenuBar: chrome.hideMenuBar ?? false,
    hideNavigationBar: chrome.hideNavigationBar ?? headerProps.hideNavigationBar,
    hideQuoteBar: hideQuoteBar ?? false,
    hideSearchBar: chrome.hideSearchBar,
    isMainDrawerVisible: chrome.isMainDrawerVisible,
    navigationLogoVariant: chrome.navigationLogoVariant ?? headerProps.navigationLogoVariant ?? 'default',
    sticky: chrome.sticky ?? headerProps.sticky ?? true,
    showRotatingBanner,
    showRaptiveBanner,
  };
}
